import { apiFetch, apiFetchBlob } from "@/api/client";
import { ENDPOINTS } from "@/api/endpoints";
import type {
  ExportPedidoReportsResult,
  PedidoReportRef,
  PedidoReportResponse,
} from "./types";

export function listPedidoReports(
  date: string,
  signal?: AbortSignal,
): Promise<PedidoReportResponse> {
  const query = new URLSearchParams({ date });
  return apiFetch(`${ENDPOINTS.reports.pedidos}?${query}`, { signal });
}

export function exportOrderPdf(orderId: string) {
  return apiFetchBlob(ENDPOINTS.reports.pedidoOrderPdf(orderId));
}

export async function exportPedidoReports(
  date: string,
  orders: PedidoReportRef[],
): Promise<ExportPedidoReportsResult> {
  const result = await apiFetchBlob(ENDPOINTS.reports.pedidosExport, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ date, orders }),
  });
  return {
    blob: result.blob,
    filename: result.filename,
    successCount: parseCount(result.headers.get("x-report-success-count")),
    failureCount: parseCount(result.headers.get("x-report-failure-count")),
  };
}

function parseCount(value: string | null) {
  const count = Number.parseInt(value ?? "0", 10);
  return Number.isFinite(count) && count >= 0 ? count : 0;
}
